import {NgProgressBrowserXhr, NgProgressModule} from 'ngx-progressbar';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormBuilder } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { ClearanceItemRouting,ClearanceItemComponent,ClearanceListComponent } from './index';
import { AppService } from '../app.service';
import { HttpModule} from '@angular/http';
import { SharedModule } from '../shared/shared.module';
import { AssetManagerModule } from '../shared/asset-manager.module';
import { ModalService } from "../shared/helper-components/modal/_services/modal.service";
import { ClearanceItemService } from "./clearance-item.service";
import { ClearanceItemHistoryComponent } from './clearance-item-history.component';
import { CarouselComponent } from './carousel.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ClearanceItemBulkModule } from './bulk-action/clearance-item-bulk.module';
import { ClearanceItemCommonModule } from './clearance-item-common.module';
import { ClearanceItemImageService } from './clearance-item-image.service';
@NgModule({
  imports: [
    SharedModule,
    ClearanceItemRouting,
    AssetManagerModule,
    BrowserAnimationsModule,
    ClearanceItemCommonModule,
    ClearanceItemBulkModule    
  ],
  declarations: [
    ClearanceListComponent,
    ClearanceItemComponent,
    ClearanceItemHistoryComponent,
    ],
  providers: [
    ClearanceItemService,
    ModalService,
    ClearanceItemImageService
  ],
})
export class ClearanceItemModule { }



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/clearance-item/clearance-item.module.ts